// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingScreen_loader__LEKwy","spin":"LoadingScreen_spin__SMbi3"};